import {connect} from '@store/@common';

import {jobs} from '@store/job';
import JobActions from '@store/job/JobActions';
import {JobId} from '@store/@types/kpi';

import {JobList} from './JobList';

const mapStateToProps = {
  jobs,
};

const mapDispatchToProps = {
  fetchJobs: JobActions.getJobsInAccount,
  deleteJob: async (id: JobId) => {
    await JobActions.deleteJob(id);
    await JobActions.getJobsInAccount();
  },
};

export default connect(JobList, mapStateToProps, mapDispatchToProps);
